import LaNordBoldWoff2 from './la-nord-bold.woff2';
import LaNordMediumWoff2 from './la-nord-medium.woff2';
import LaNordRegularWoff2 from './la-nord-regular.woff2';
import InterBoldWoff2 from './inter-bold.woff2';
import InterSemiBoldWoff2 from './inter-semibold.woff2';
import InterRegularWoff2 from './inter-regular.woff2';

export const LaNordBold = {
    fontFamily: 'La Nord',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 700,
    src: `url(${LaNordBoldWoff2}) format('woff2')`,
    unicodeRange: 'U+0000-00FF',
};

export const LaNordMedium = {
    fontFamily: 'La Nord',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 500,
    src: `url(${LaNordMediumWoff2}) format('woff2')`,
    unicodeRange: 'U+0000-00FF',
};

export const LaNordRegular = {
    fontFamily: 'La Nord',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `url(${LaNordRegularWoff2}) format('woff2')`,
    unicodeRange: 'U+0000-00FF',
};

export const InterBold = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 700,
    src: `url('${InterBoldWoff2}') format('woff2')`,
    unicodeRange: 'U+0000-00FF',
};

export const InterSemiBold = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 600,
    src: `url('${InterSemiBoldWoff2}') format('woff2')`,
    unicodeRange: 'U+0000-00FF',
};

export const InterRegular = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `url('${InterRegularWoff2}') format('woff2')`,
    unicodeRange: 'U+0000-00FF',
};
